/**
 * The default page size for all search requests
 * @type {number}
 */
export const DEFAULT_PAGE_SIZE = 60;

/**
 * The Constructor.io index section to query.
 * @type {string}
 */
export const DEFAULT_SECTION = 'Products';

/**
 * The Constructor.io Autocomplete section for term suggestions, returned
 * alongside `Products`.
 * @type {string}
 */
export const SUGGESTIONS_SECTION = 'Search Suggestions';

/**
 * The Constructor.io facet/field name that holds the category code.
 * @type {string}
 */
export const BROWSE_FILTER_NAME = 'group_id';

/**
 * Default number of products requested from a recommendations pod when a
 * component does not set its own `limit`. Constructor caps `num_results` at
 * 100.
 * @type {number}
 */
export const DEFAULT_RECOMMENDATIONS_LIMIT = 10;

/**
 * @type {Record<string, string>}
 */
export const RECOMMENDATIONS_PAGE_TYPES = {
	CART: 'cart',
	HOME: 'home',
	PDP: 'pdp',
	PLP: 'plp'
};

/**
 * @type {string[]}
 */
export const SEEDED_PAGE_TYPES = [
	RECOMMENDATIONS_PAGE_TYPES.CART,
	RECOMMENDATIONS_PAGE_TYPES.PDP
];

/**
 * @type {Record<string, string>}
 */
export const RECOMMENDATION_TYPES = {
	PDP_ALSO_LIKE: 'PDP_ALSO_LIKE',
	PDP_FANS_ALSO_LIKE: 'PDP_FANS_ALSO_LIKE'
};

/**
 * @type {boolean}
 */
export const EXCLUDE_CURRENTLY_UNAVAILABLE = true;

/**
 * The page URL query parameter carrying Constructor user segments
 * (`?us=<segment>`; repeatable).
 * @type {string}
 */
export const USER_SEGMENT_PARAM = 'us';

/**
 * The Constructor `group_id` value for the root/top-level category,
 * representing the entire catalog.
 * @type {string}
 */
export const ALL_PRODUCTS_GROUP_ID = 'all';
